import PropTypes from 'prop-types';
import pick from 'lodash.pick';
import { ContentStateShape } from 'next/lib/shapes';

/**
 * Full shape of flow data model
 */
const Shape = {
  createdAt: PropTypes.number,
  createdBy: PropTypes.string,
  formatVersion: PropTypes.number,
  formatVersionUpdatedAt: PropTypes.number,
  id: PropTypes.string,
  lockedForLocalization: PropTypes.bool,
  name: PropTypes.string,
  previewUrl: PropTypes.string,
  published: PropTypes.bool,
  publishedAt: PropTypes.string,
  state: ContentStateShape,
  // FIXME: Define full shape of step
  steps: PropTypes.objectOf(PropTypes.object),
  tagIds: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.oneOf(['journey']),
  updatedAt: PropTypes.number,
  updatedBy: PropTypes.string,
};

/**
 * Allowed fields for storage
 */
const allowed = [
  'createdAt',
  'createdBy',
  'id',
  'name',
  'previewUrl',
  'published',
  'publishedAt',
  'state',
  'steps',
  'tagIds',
  'updatedAt',
  'updatedBy',
];

/**
 * Flow parsing function
 *
 * @param {Object<keyof Flow>} flow - Object with flow fields
 * @return {Object<keyof Flow>} Object with parsed flow fields
 */
export const parse = flow => pick(flow, allowed);

export default PropTypes.shape(parse(Shape));
